import { Injectable } from "@angular/core";

/**
 * Service to store the OAuth access token in memory
 * Token is only used for the first authenticated request to establish a session
 */
@Injectable()
export class TokenStorageService {
  private token: string | null = null;

  setToken(token: string): void {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  clearToken(): void {
    this.token = null;
  }
}
